function b64toBlob(base64: string, type = "application/octet-stream") {
  return fetch(`data:${type};base64,${base64}`).then(res => res.blob());
}

export default b64toBlob;
